import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Lists/ChildListView/Items'

export default createChildListViewContainer()(Component)
